The details of an available advertisement product.
